import template from './billable_events.all.html'
import controller from './billable_events.all.controller'
import './billable_events.all.scss'

const billableEventsAllComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default billableEventsAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billable_events/all/billable_events.all.component.js